import styled from 'styled-components/macro';

const sidePadding = '40px';

export const InnerSection = styled.div`
  padding: 30px ${sidePadding} 40px;

  &:not(:first-child) {
    padding: 40px ${sidePadding};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-right: 15px;
  }
`;
